import React, { ReactElement, createContext, useContext, useEffect, useState } from 'react';
import { IIssuer } from '../interfaces/issuers';

const useGetRouteIssuerFromLocalStorage= () =>{
  const appData = localStorage.getItem('appData');
  var routeIssuer =  getIssuerFromPath();

  if (appData && !!JSON.parse(appData)?.settings?.routeIssuer) {
    routeIssuer = JSON.parse(appData)?.settings?.routeIssuer;
  }

  return routeIssuer;
}

const getIssuerFromPath = () =>{
  return  window.location.pathname.split('/')?.[1]?.toUpperCase();
}

const useSaveAppDataToLocalStorage = (data: any) => {
  const appData = JSON.parse(localStorage.getItem('appData') ?? '{}');

  localStorage.setItem('appData', JSON.stringify(appData ? { ...appData, ...data } : data));
};

const useSaveSettingAttributeAppDataToLocalStorage = (attribute: string, value: IIssuer | string) => {
  const appData = JSON.parse(localStorage.getItem('appData') ?? '{}');
  var data = {
    settings: {}
  }

  if (appData && !!appData?.settings) {
    data = appData
  }

  data[attribute] = value;

  localStorage.setItem('appData', JSON.stringify(appData ? { ...appData, ...data } : data));
};

const AppContext = createContext<{
  settings: {
    issuer: IIssuer;
    routeIssuer: string;
    getIssuer?: () => IIssuer;
    setIssuer?: (issuer: IIssuer) => void;
    getRouteIssuer?: () => string;
  };
}>({
  settings: {
    issuer: null,
    routeIssuer:  getIssuerFromPath()
  },
});

export const AppContextProvider =  ({ children }: { children: ReactElement }) => {

  const [issuerSettings, setIssuerSettings] = useState<IIssuer>();

  const [issuerRouteSettings, setIssuerRouteSettings] = useState(
    useGetRouteIssuerFromLocalStorage()
  );

  useEffect(() => {
    setIssuerRouteSettings(
      useGetRouteIssuerFromLocalStorage()
    );
  }, []);

  useEffect(() => {
    useSaveSettingAttributeAppDataToLocalStorage("issuer", issuerSettings);
  }, [issuerSettings]);

  useEffect(() => {
    useSaveSettingAttributeAppDataToLocalStorage("routeIssuer", issuerRouteSettings);
  }, [issuerRouteSettings]);

  const setIssuer = (issuer: IIssuer) => {
    setIssuerSettings(
      issuer
    );
  };

  const getIssuer = () => {
    return issuerSettings;
  };

  const getRouteIssuer = () => {
    return issuerRouteSettings;
  }

  return (
    <AppContext.Provider
      value={{
        settings: {
          issuer: issuerSettings,
          routeIssuer: issuerRouteSettings,
          setIssuer,
          getIssuer,
          getRouteIssuer
        },
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): {
  settings: {
    issuer: IIssuer;
    routeIssuer: string;
    getIssuer?: () => IIssuer;
    setIssuer?: (issuer: IIssuer) => void;
    getRouteIssuer?: () => string;
  };
} => {
  return useContext(AppContext);
};
